export default __webpack_public_path__ + "static/media/2229.ce1b5645.png";